import type { VariantProps } from "class-variance-authority";
import { createContext, use } from "react";

import type { itemStyles } from "./style";

export const RadioGroupRootContext = createContext<
  Partial<VariantProps<typeof itemStyles>> & {
    disabled?: boolean;
  }
>({});

export const useRadioGroupRootContext = () => use(RadioGroupRootContext);
